import { makeStyles } from "@material-ui/core/styles";

export const PreloaderStyle = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
}), {index: 1});